import React from 'react';
import { View, Text } from 'react-native';

import {loadStripe} from '@stripe/stripe-js';

import {
  CardNumberElement, 
  CardExpiryElement, 
  CardCvcElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as ht from './_ht';
import * as cr from './_cr';
import * as icv from 'src/icv';

import { a } from './_csAbt';

import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as TextC from './_ccbTextC';

import * as gs from './_csGbl';
import * as ls from './_csLcl';
import { useCfmz } from './_csMdlCfm';

import * as cmFTH from './_cmFTH';

import * as _cv_10___Mz from './_cv_10___Mz';
import * as _cv_80___Mz from './_cv_80___Mz';

import {
  useLdrz
} from './_csLdr'; 

export type tSrp = {
  pmtType: 'once' | 'ssn', // payment type
  _802t1100s: ht.s,
  _802a1100k: ht.s,
  _81rt1100s: ht.s,
  _81ra1100k: ht.n,
  trnId?: ht.s, // transaction id
  cmrName: ht.s, // customer name
  pmtDrn: ht.s, // payment description 
  pmtAmt: ht.n, // payment amount
  prcId?: ht.s, // price id
  pmtDate?: ht.s, // payment date
//  atrScd?: ( _dz?: ht.dz) => void,
  atrScd?: ( _dz?: ht.dz) => void,
  onCls: () => void,
  bCpn?: ht.b, // coupon
//  plcKey: ht.s, // public key
};

export const N = (pz: tSrp) => {

//  const _oSrp = useLclAny(loadStripe(icv.srpz.plcKey));
//  const _oSrp = ls.useAny(loadStripe('pk_test_51KzrgYJecrwlofZqyrP8LCRKUM0PFE8GSsfp8CbxZqONQWg8AYoJ6rjNo8iFPqETgZjEzHDPV2buh3o2HpQpGzlL00XN2SM3C6'));
  const _gUserz = gs.useUserz();
  const _oSrp = ls.useAny(loadStripe(_gUserz.crt._801z._801a2100s));

  return (
    cr.c(Elements, {
      key: 'Srp.root',
      stripe: _oSrp.crt,
    }, [
      cr.c($Cld, {
        ... pz,
        key: -10,
      })
    ])
  );

};

let $pmnCode = '';

const $Cld = (pz: tSrp) => {

  const _gUserz = gs.useUserz();
  const _sCfmz = useCfmz();

  const _sLdrz = useLdrz();

  const stripe = useStripe();
  const elements = useElements();

  const _getCmrId = async ( // get customer id
  ) => {
    const __80z = await _cv_80___Mz.load_81rDzAsync({
      _81rt1100s: pz._81rt1100s,
      _81ra1100k: pz._81ra1100k,
      lwrType: 1,
    });
    if (hf.f(__80z?._81rz?._81ra2100s)) {
      return __80z?._81rz?._81ra2100s
    }
    else {
      return await _crtCmrId();
    }
  };

  const _crtCmrId = async ( // create customer id
  ) => {
    const _dz1 = {
      cmrName: pz.cmrName,
      mdtz: {
        _81rt1100s: pz._81rt1100s,
        _81ra1100k: pz._81ra1100k,
      },
    };
    const _dz2 = await cmFTH.sendAsync({
      url: icv.appz.urlb + '/srp/crtCmr',
      mtd: 'POST',
      dz: _dz1,
    }) as ht.dz;
    const __80z2 = _cv_80___Mz.crt_80z();
    hf.udtDz(__80z2._81rz, {
      _81ra2100s: _dz2.data.cmrId,
    })
    await _cv_80___Mz.save_81rDzAsync({
      _80z: __80z2,
    });
    return _dz2.data.cmrId

  };

  const _getCpn = async ( // get coupon id
    pmnCode: ht.s,
  ) => {
    const _dz1 = {
      pmnCode: pmnCode
    };
    const _dz2 = cmFTH.sendAsync({
      url: icv.appz.urlb + '/srp/getCpn',
      dz: _dz1,
    }) as ht.dz;
    return _dz2.data;
  };

  const _crtSsn = async ( // create subscription
    cmrId: ht.s, // customer id
    cpnId?: ht.s, // coupon Id
  ) => {
    const _dz1 = {
      cmrId: cmrId,
      prcId: pz.prcId,
      cpnId: cpnId
    };
    const _dz2 = await cmFTH.sendAsync({
      url: icv.appz.urlb + '/srp/crtSsn',
      dz: _dz1,
    });
    const __80z = await _cv_80___Mz.load_81rDzAsync({
      _81ra2100s: cmrId,
    })
    __80z._811s.push({
      _811a1100s: _dz2.data.ssnId,
      _811s1100i: 1,
      _811a2100s: pz.prcId,
      _811a3100s: cpnId,
    });
    await _cv_80___Mz.save_81rDzAsync({
      _80z: __80z,
    })
    return _dz2.data as ht.dz;
  };

  const _cclSsn = async (pz2:{ // cancel subscription
    _811a1100s: ht.s,
  }) => {
    const _dz1 = {
      ssnId: pz2._811a1100s,
    };
    await cmFTH.sendAsync({
      url: icv.appz.urlb + '/srp/cclSsn',
      mtd: 'POST',
      dz: _dz1,
    });
    const __80z = await _cv_80___Mz.load_81rDzAsync({
      _811a1100s: pz2._811a1100s,
      lwrType: 1,
    });
    hf.udtDz(hf.get1(__80z._811s), {
      _811s1100i: -1,
    });
    const _rz =  await _cv_80___Mz.save_81rDzAsync({
      _80z: __80z,
    });
    return _rz;
  };

  const _smtOnce = async (event: ht.a) => {
    event.preventDefault();
    _sLdrz.show();

    const _dz = { 
      _802t1100s: pz._802t1100s,
      _802a1100k: pz._802a1100k,
      pmtAmt: pz.pmtAmt,
      pmtDrn: pz.pmtDrn,
      mdtz: {
        _81rt1100s: pz._81rt1100s,
        _81ra1100k: pz._81ra1100k,
        trnId: pz.trnId,
        cmrName: pz.cmrName,
      }
    };
    const _dz2 = await cmFTH.sendAsync({
      url: icv.appz.urlb + '/srp/crtOnce',
      mtd: 'POST',
      dz: _dz,
    })

    const _rz = await stripe.confirmCardPayment(_dz2.data.client_secret, {
      payment_method: {
        card: elements.getElement(CardNumberElement),
        billing_details: {
          name: pz.cmrName,
        },
      },
    })

    _sLdrz.hide();
    if (_rz.error) {
      _sCfmz.show({
        pfx: `${_rz.error.message}(${(_rz.error.code) ? _rz.error.code : ''}${(_rz.error.decline_code) ? ', ' + _rz.error.decline_code : ''})`,
        ls: [{ key: 1, pfx: 'はい' }]
      });
    }
    else if (_rz.paymentIntent.status === "succeeded") {
      _sCfmz.show({
        pfx: `支払が完了しました`,
        ls: [{ key: 1, pfx: 'はい' }],
        onPrs: () => {
          if (pz.atrScd) pz.atrScd();
        }
      });
    }

  };

  const _smtSsn = async (event: ht.a) => {
    event.preventDefault();
    _sLdrz.show();

    const _cpnz = 
      pz.bCpn && hf.f($pmnCode) ? 
      await _getCpn($pmnCode)
      : undefined;

    if (
      pz.bCpn && 
      hf.f($pmnCode) && 
      !hf.f(_cpnz?.id)
    ) {
      _sLdrz.hide();
      _sCfmz.show({
        pfx: `誤ったクーポンコードが入力されているため、処理を進めることができません。`,
        ls: [{ key: 1, pfx: 'はい' }]
      });
    }
    else {

      const _cmrId = await _getCmrId();

      if (!_cmrId) {
        _sLdrz.hide();
        _sCfmz.show({
          pfx: `エラーが発生したため、処理を進めることができません。`,
          ls: [{ key: 1, pfx: 'はい' }]
        });
      }
      else {

        const __80z = await _cv_80___Mz.load_81rDzAsync({
          _81ra2100s: _cmrId,
          lwrType: 1,
        })

        await hf.ectSrlAsync(__80z._811s?.map((_811z: ht.dz) => async () => { // 既存 subscription のキャンセル
          await _cclSsn(_811z._811a1100s)
          return true;
        }));

        const _dz = await _crtSsn(_cmrId, _cpnz.id);

        const _rz = await stripe.confirmCardPayment( // 処理完了前の hideMdl でエラー発生
          _dz.cltSrt, 
          {
            payment_method: {
              card: elements.getElement(CardNumberElement),
              billing_details: {
                name: pz.cmrName,
              },
            },
          }
        );

        _sLdrz.hide();
        if (_rz.error) {
          _sCfmz.show({
            pfx: `${_rz.error.message}(${(_rz.error.code) ? _rz.error.code : ''}${(_rz.error.decline_code) ? ', ' + _rz.error.decline_code : ''})`,
            ls: [{ key: 1, pfx: 'はい' }]
          });
        }
        else if (_rz.paymentIntent.status === "succeeded") {
          _sCfmz.show({
            pfx: `支払が完了しました`,
            ls: [{ key: 1, pfx: 'はい' }],
            onPrs: () => {
              if (pz.atrScd) pz.atrScd(_cpnz);
            }
          });
        }

      }

    }

  }

  return (

    cr.c('form', {
      key: -10,
      style: a(`dw/f`),
      onSubmit: 
        pz.pmtType == 'once' ? 
          _smtOnce
        : pz.pmtType == 'ssn' ? 
          _smtSsn
        : undefined
    }, [

      cr.c(TextC.N, {
        key: -1110,
        boxStlz: a(`dw/f mh/a mb/1 mt/1`),
        textz: {
          pfx: 
            pz.bCpn ?
              `カード番号・有効期限・CVC(カード記載の確認コード)・クーポンコード（任意）を入力した後、「送る」ボタンを押してください。`
            : `カード番号・有効期限・CVC(カード記載の確認コード)を入力した後、[送る]ボタンを押してください。`,
          stlz: a(`ts/m tc/lt9 ta/l`),
        }
      }),

      cr.c(TextC.N, {
        key: -1120,
        boxStlz: a(`dw/f mh/a mb/2 mt/1`),
        textz: {
          pfx: `※ カード情報が本システムに保存されることはありません。`,
          stlz: a(`ts/s tc/lt9 ta/l`),
        }
      }),

      cr.c(GridC.N, {
        key: -2110,
        abtType: 'nolineCmnz',
        boxStlz: a(`br/1 dw/f mb/2 mh/a pt/1 ph/1 sc/lt2`),
        lineCs: [
          {
            boxStlz: a('mb/0.5'),
            cellCs: [
              {
                boxStlz: a('fd/rcc f/0.3'),
                oClds: [
                  cr.c(TextC.N, {
                    key: -10,
                    textz: {
                      stlz: a(`tb tc/lt9 ts/m`),
                      pfx: `お名前`
                    }
                  }),
                ]
              },
              {
                oClds: [
                  cr.c('input', {
                    key: -20,
                    name: "name",
                    defaultValue: pz.cmrName,
                    style: a(`dw/f ts/m bw/0 sc/t pl/1`),
                    size: 20,
                    readOnly: true,
                  }),
                ]
              }
            ]
          },
          {
            boxStlz: a('mb/0.5'),
            cellCs: [
              {
                boxStlz: a('fd/rcc f/0.3'),
                oClds: [
                  cr.c(TextC.N, {
                    key: -10,
                    textz: {
                      stlz: a(`tb tc/lt9 ts/m`),
                      pfx: `内容`
                    }
                  }),
                ]
              },
              {
                oClds: [
                  cr.c('input', {
                    key: -20,
                    name: "ttl",
                    defaultValue: pz.pmtDrn, 
                    style: a(`dw/f ts/m bw/0 sc/t pl/1`),
                    size: 20,
                    readOnly: true,
                  }),
                ]
              }
            ]
          },
          {
            boxStlz: a('mb/0.5'),
            cellCs: [
              {
                boxStlz: a('fd/rcc f/0.3'),
                oClds: [
                  cr.c(TextC.N, {
                    key: -10,
                    textz: {
                      stlz: a(`tb tc/lt9 ts/m`),
                      pfx: `金額`
                    }
                  }),
                ]
              },
              {
                oClds: [
                  cr.c('input', {
                    key: -20,
                    name: "amt",
                    defaultValue: '¥' + hf.cvtCmm(pz.pmtAmt ?? 0), 
                    style: a(`dw/f ts/m bw/0 sc/t pl/1`),
                    size: 20,
                    readOnly: true,
                  }),
                ]
              }
            ]
          },
          pz.pmtDate ?
          {
            boxStlz: a('mb/0.5'),
            cellCs: [
              {
                boxStlz: a('fd/rcc f/0.3'),
                oClds: [
                  cr.c(TextC.N, {
                    key: -10,
                    textz: {
                      stlz: a(`tb tc/lt9 ts/m`),
                      pfx: `お支払日`
                    }
                  }),
                ]
              },
              {
                oClds: [
                  cr.c('input', {
                    key: -20,
                    name: "date",
                    defaultValue: pz.pmtDate, 
                    style: a(`dw/f ts/m bw/0 sc/t pl/1`),
                    size: 20,
                    readOnly: true,
                  }),
                ]
              }
            ]
          }
          : undefined,
        ]
      }),

      cr.c(TextC.N, {
        key: -3110,
        boxStlz: a('dw/f fd/rsc'),
        textz: {
          stlz: a(`tb tc/lt9 ts/m`),
          pfx: `カード番号`
        }
      }),

      cr.c('div', { 
        key: -3120,
        style: a(`bc/lt5 br/1 bs/sd bw/1 pv/1 ph/1 mb/1`),
      }, [
        cr.c(CardNumberElement, {
          key: -10,
          options: {
            style: {
              base: {
                ... a(`tc/lt9 ts/m`),
                '::placeholder': a('tc/lt4'),
              },
            },
          }
        })
      ]),

      cr.c(TextC.N, {
        key: -3210,
        boxStlz: a('dw/f fd/rsc'),
        textz: {
          stlz: a(`tb tc/lt9 ts/m`),
          pfx: `有効期限`
        }
      }),

      cr.c('div', { 
        key: -3220,
        style: a(`bc/lt5 br/1 bs/sd bw/1 pv/1 ph/1 mb/1`),
      }, [
        cr.c(CardExpiryElement, {
          key: -10,
          options: {
            style: {
              base: {
                ... a(`tc/lt9 ts/m`),
                '::placeholder': a('tc/lt4'),
              },
            },
          }
        })
      ]),

      cr.c(TextC.N, {
        key: -3310,
        boxStlz: a('dw/f fd/rsc'),
        textz: {
          stlz: a(`tb tc/lt9 ts/m`),
          pfx: `CVC(カード記載の確認コード)`
        }
      }),

      cr.c('div', { 
        key: -3320,
        style: a(`bc/lt5 br/1 bs/sd bw/1 pv/1 ph/1 mb/1`),
      }, [
        cr.c(CardCvcElement, {
          key: -10,
          options: {
            style: {
              base: {
                ... a(`tc/lt9 ts/m`),
                '::placeholder': a('tc/lt4'),
              },
            },
          }
        }) 
      ]),

      pz.bCpn ?
      cr.c(TextC.N, {
        key: -3410,
        boxStlz: a('dw/f fd/rsc'),
        textz: {
          stlz: a(`tb tc/lt9 ts/m`),
          pfx: `クーポンコード`
        }
      })
      : undefined,

      pz.bCpn ?
      cr.c('div', { 
        key: -3420,
        style: a(`bc/lt5 br/1 bs/sd bw/1 pv/1 ph/1 mb/1`),
      }, [
        cr.c('input', {
          key: -10,
          name: "pmnCode",
          defaultValue: '',
          placeholder: '任意',
          style: {
            ... a(`bc/t bw/0 dh/f dw/f p/0 sc/t ts/m`),
            outline: 'none',
          },
          onChange: (_e: ht.dz) => {
            $pmnCode = _e.target.value;
          }
        })
      ])
      : undefined,

      cr.c('button', {
        key: -3510,
        type: "submit",
        style: a(`br/1 bw/0 dw/f dh/4 mb/1 mt/1 tb tc/lt1 ts/m sc/lt5`),
      }, 
        '送る'
      )

    ])
  );

};
